import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Вторичная подпись: «Паспорт», «Источник: …», пояснение вместо кнопок.
 *
 * Кегль, межстрочное и цвет объявлены у себя. Раньше элементом был вкуишный
 * Footnote, и типографика приезжала от платформы: его правило висит на ДВУХ
 * классах и перебивает наш один, поэтому межстрочное приходило 1.23 вместо
 * 1.45 — проверено замером в браузере. Своего смысла у Footnote тут нет,
 * это просто подпись.
 */
export function Muted({
  children,
  tone = 'default',
  block = false,
}: {
  children: ReactNode;
  /** Отдельной строкой, а не внутри ряда: сообщение под кнопкой. */
  block?: boolean;
  /**
   * `negative` — текст ошибки: он тоже мелкий и вторичный. `lilac` — вид
   * заявки в ленте решений: в макете он назван цветом, а не рамкой, потому
   * что стоит в одном ряду со значком вердикта и спорил бы с ним коробкой.
   */
  tone?: 'default' | 'negative' | 'lilac';
}) {
  return (
    <span className={clsx(styles.muted, TONES[tone], block && styles.mutedBlock)}>{children}</span>
  );
}

const TONES = {
  default: '',
  negative: styles.mutedNegative,
  lilac: styles.mutedLilac,
};
